@if (store.isDrawerOpen()) {
  <div class="fixed inset-0 z-100000">
    <button
      type="button"
      aria-label="Close filter drawer"
      class="absolute inset-0 bg-gray-900/50 backdrop-blur-[1px]"
      (click)="toggleDrawer()"

    ></button>

    <section class="absolute inset-y-0 right-0 flex w-full max-w-2xl flex-col overflow-hidden bg-white shadow-2xl dark:bg-gray-900">
      <div class="flex items-start justify-between border-b border-gray-200 px-4 py-4 dark:border-gray-800 sm:px-6">
        <div>
          <h2 class="text-base font-semibold text-gray-900 dark:text-white">{{ 'app.label.network.and.period.filters' | translate }}</h2>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {{ 'app.message.choose.network.and.period.filters' | translate }}
          </p>
        </div>
        <button
          type="button"
          class="rounded-md p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
          (click)="toggleDrawer()"
        >
          <span class="sr-only">{{ 'app.label.close.panel' | translate }}</span>
          <svg class="h-5 w-5 fill-current" viewBox="0 0 20 20">
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>
      </div>

      <div class="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-3 dark:border-gray-800 sm:px-6">
        <p class="text-sm text-gray-600 dark:text-gray-300">
          {{ 'app.label.active.selections' | translate }}: <span class="font-semibold text-gray-900 dark:text-white">{{ draftActiveFilterCount() }}</span>
        </p>
        <div class="flex items-center gap-2">
          <app-button size="sm" variant="outline" (btnClick)="clearAll()">
            {{ 'app.label.clear.all' | translate }}
          </app-button>
          <app-button size="sm" variant="primary" (btnClick)="applyFilter()">
            {{ 'app.label.apply' | translate }}
          </app-button>
        </div>
      </div>

        <div class="flex-1 overflow-y-auto px-4 py-5 sm:px-6">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          @for (field of filterFields; track field.label) {
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ field.label | translate }}</mat-label>
                <mat-select
                  multiple
                  [value]="getSelectedModel(field.key)"
                  (selectionChange)="onSelectionChange($event.value, field.key)"
                >

                  <mat-select-trigger>
                    <span class="capitalize"> {{ getSelectionSummary(field.key) }} </span>
                  </mat-select-trigger>

                  <input
                    class="w-full network-filter-search-input"
                    matInput
                    [placeholder]="'app.label.type.to.filter.options' | translate"
                    [ngModel]="getSearchTerm(field.key)"
                    (ngModelChange)="onSearchChange($event, field.key)"
                  />

                  @if(field.key === 'agents'){
                      @for (option of getFilteredAgentOptions(); track option) {
                        <mat-option [value]="option.id"><span class="capitalize">{{ option.name }}</span></mat-option>
                      }
                  } @else {
                    @for (option of getFilteredOptions(field.key); track option) {
                      <mat-option [value]="option"><span class="capitalize">{{ option }}</span></mat-option>
                    }
                  }

                  @if(!getFilteredOptions(field.key).length){
                    <mat-option disabled>{{ "No matching" | translate }} {{ field.label | translate }} {{ "found" | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="mt-6 border-t border-gray-200 pt-6 dark:border-gray-800">
          <h3 class="mb-4 text-sm font-semibold text-gray-900 dark:text-white">{{ 'app.label.period.data' | translate }}</h3>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'app.label.temporal.period' | translate }}</mat-label>
            <mat-select
              [value]="draftPeriodFilter().periodType"
              (selectionChange)="onPeriodTypeChange($event.value)"
            >
              <mat-select-trigger>
                {{ getPeriodSelectionSummary() | translate }}
              </mat-select-trigger>

              <input
                class="w-full network-filter-search-input"
                matInput
                [placeholder]="'app.label.type.to.filter.periods' | translate"
                [ngModel]="periodSearchTerm()"
                (ngModelChange)="onPeriodSearchChange($event)"
              />

              @for (option of getFilteredPeriodOptions(); track option.value) {
                <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
              }

              @if (!getFilteredPeriodOptions().length) {
                <mat-option disabled>{{ 'app.message.no.matching.period.found' | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (showPeriodDatePickers()) {
            <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
              <div class="space-y-4">
                <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'app.label.current' | translate }}</p>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{ 'app.label.from' | translate }}</mat-label>
                  <input matInput [matDatepicker]="currentFromPicker" [ngModel]="draftPeriodFilter().currentFrom" (dateChange)="onCurrentFromChange($event.value)" />
                  <mat-datepicker-toggle matIconSuffix [for]="currentFromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #currentFromPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{ 'app.label.to' | translate }}</mat-label>
                  <input matInput [matDatepicker]="currentToPicker" [ngModel]="draftPeriodFilter().currentTo" (dateChange)="onCurrentToChange($event.value)" />
                  <mat-datepicker-toggle matIconSuffix [for]="currentToPicker"></mat-datepicker-toggle>
                  <mat-datepicker #currentToPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="space-y-4">
                <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ 'app.label.previous' | translate }}</p>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{ 'app.label.from' | translate }}</mat-label>
                  <input matInput [matDatepicker]="previousFromPicker" [ngModel]="draftPeriodFilter().previousFrom" (dateChange)="onPreviousFromChange($event.value)" />
                  <mat-datepicker-toggle matIconSuffix [for]="previousFromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #previousFromPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{ 'app.label.to' | translate }}</mat-label>
                  <input matInput [matDatepicker]="previousToPicker" [ngModel]="draftPeriodFilter().previousTo" (dateChange)="onPreviousToChange($event.value)" />
                  <mat-datepicker-toggle matIconSuffix [for]="previousToPicker"></mat-datepicker-toggle>
                  <mat-datepicker #previousToPicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          } @else {
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ 'app.message.current.and.previous.dates.automatically.calculated' | translate }}
            </p>
          }
        </div>
      </div>
    </section>
  </div>
}
